import { Pane } from "../../Common/FrontPage/pane";
import "../../Common/FrontPage/frontPage.scss";
import "../../Common/FrontPage/frontPagePerCompany.scss";

export function Index() {
  return (
    <div className="-mko-location-front-page">
      <h1>Zgody</h1>

      <div className="-mko-lfp-panes-container">
        <Pane link="../EInvoice/Index" text="E-faktury" />
      </div>
    </div>
  );
}
